import React from 'react';
import './Skeletons.css';

const ResultCardSkeleton = () => {
    return (
        <div className="result-card-skeleton-wrapper">
            {/* Rectangle 160356 */}
            <div className="result-skeleton-line-short shimmer-bg"></div>

            {/* Rectangle 160357 */}
            <div className="result-skeleton-line-long shimmer-bg"></div>

            {/* Rectangle 160359 */}
            <div className="result-skeleton-line-long shimmer-bg"></div>

            {/* Rectangle 160360 */}
            <div className="result-skeleton-line-long shimmer-bg"></div>

            <div className="result-skeleton-bottom-group">
                {/* Lower Rectangle 160360 (Short) */}
                <div className="result-skeleton-line-short shimmer-bg"></div>

                {/* Rectangle 160358 (Button) */}
                <div className="result-skeleton-button shimmer-bg"></div>
            </div>
        </div>
    );
};

export default ResultCardSkeleton;
